import { Roles } from '@cbgms/api/modules/enums'

export const ROLES_OPTIONS = [
  { key: Roles.None, value: Roles.None, text: 'None' },
  { key: Roles.Telesales, value: Roles.Telesales, text: 'Telesales' },
  { key: Roles.SupportDesk, value: Roles.SupportDesk, text: 'Support desk' },
  { key: Roles.LKQConceptManager, value: Roles.LKQConceptManager, text: 'Concept manager' },
  { key: Roles.LKQProductManager, value: Roles.LKQProductManager, text: 'Product manager' },
  { key: Roles.Admin, value: Roles.Admin, text: 'Admin' },
  { key: Roles.LessorAndConcept, value: Roles.LessorAndConcept, text: 'Lessor & concept' },
  { key: Roles.DACHTelesales, value: Roles.DACHTelesales, text: 'DACH Telesales' },
  { key: Roles.DACHTelesalesSupervisor, value: Roles.DACHTelesalesSupervisor, text: 'DACH Telesales Supervisor User' },
  { key: Roles.DACHSuperUser, value: Roles.DACHSuperUser, text: 'DACH Super User' },
  { key: Roles.DACHSupportDesk, value: Roles.DACHSupportDesk, text: 'DACH Support Desk' },
  { key: Roles.DACHSupportAdmin, value: Roles.DACHSupportAdmin, text: 'DACH Support Admin' },
  { key: Roles.DACHMarketing, value: Roles.DACHMarketing, text: 'DACH Marketing' }
]
